import CallHistoryDetailPageV2 from 'flow/components/pbx/v2/detail-page/CallHistoryDetailPageV2';

const AiCoworkerCallRecordDetailPageV2 = () => (
    <CallHistoryDetailPageV2
        pageType="ai-agent"
        segmentContext="AI agent call detail"
        tabsHidden={['RELATED']}
    />
);

export default AiCoworkerCallRecordDetailPageV2;
